import React, { forwardRef } from 'react';

import { H1, P1 } from '@repo/ui-kit/components/core/Typography';

import { FlexColumn } from 'styles/layouts';

import { ImageTextTile } from '../shared/ImageTextTile';
import { ComponentContainer, ComponentWrapper } from '../shared/styles';

import { CategoryWrapper } from './styles';
import { CategoryListGridProps } from './types';

export const CategoryListGrid = forwardRef<
  Record<string, HTMLDivElement>,
  CategoryListGridProps
>(({ title, description, items, backgroundColor }, categoriesRefs) => {
  return (
    <ComponentWrapper
      ref={(el) => {
        if (
          typeof categoriesRefs !== 'function' &&
          categoriesRefs?.current &&
          el
        ) {
          categoriesRefs.current[title] = el;
        }
      }}
      id={title}
    >
      <ComponentContainer>
        <FlexColumn gap="24px">
          <FlexColumn gap="20px">
            <H1 bold as="h2">
              {title}
            </H1>
            <P1>{description}</P1>
          </FlexColumn>
          <CategoryWrapper>
            {items.map((item, index) => (
              <ImageTextTile
                key={index}
                backgroundColor={backgroundColor}
                image={item.image}
                title={item.title}
                url={item.url}
              />
            ))}
          </CategoryWrapper>
        </FlexColumn>
      </ComponentContainer>
    </ComponentWrapper>
  );
});

CategoryListGrid.displayName = 'CategoryListGrid';
